export const backendDomain = process.env.REACT_APP_BACKEND_DOMAIN
export const rawBackendUrl = `https://${backendDomain}/api`
export const backendUrl = `https://${backendDomain}/api/moa`

export const SMS_TIMER = process.env.REACT_APP_SMS_TIMER || 120
